import { EmployeeMergeData } from '../../data/employee.merge.data';

export class FakeEmployeeMergeData extends EmployeeMergeData {

    constructor() {
        super();

        this._id = '0c573a9a-a442-4d40-865b-b2225e13b41d';
        this.firstName = 'John';
        this.lastName = 'Smith';
        this.name = [this.firstName, this.lastName].join(' ');
        this.mobile = '0409 252 252';
        this.workPhone = '02 8002 9599';
        this.email = 'john.smith@workbuddy.com';
        this.tags = 'Electrical, HVAC';
    }

}